import { useState } from 'react'
import { Link } from 'react-router'
import { useLanguage } from '../context/LanguageContext'

const STORAGE_KEY = 'ng-cookie-consent'

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return !stored
  })
  const { t } = useLanguage()

  const persistChoice = (choice) => {
    window.localStorage.setItem(STORAGE_KEY, choice)
    window.dispatchEvent(new CustomEvent('ng-cookie-consent', { detail: choice }))
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] md:left-auto md:right-4 md:max-w-md">
      <div className="rounded-2xl border border-ng-dark/10 bg-white p-5 shadow-2xl">
        <p className="font-display text-lg font-semibold text-ng-dark mb-2">{t('common.cookiesTitle')}</p>
        <p className="text-sm leading-relaxed text-ng-dark/70 mb-4">
          {t('common.cookiesText')}{' '}
          {t('common.seeOur')} <Link to="/politique-de-confidentialite" className="underline hover:text-ng-dark">{t('common.privacy')}</Link>.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={() => persistChoice('rejected')}
            className="px-4 py-2 rounded-full border border-ng-dark/15 text-sm font-medium text-ng-dark hover:bg-ng-dark/5 transition-colors"
          >
            {t('common.reject')}
          </button>
          <button
            type="button"
            onClick={() => persistChoice('accepted')}
            className="px-4 py-2 rounded-full bg-ng-dark text-white text-sm font-medium hover:bg-ng-mid transition-colors"
          >
            {t('common.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}